import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import useTranslations from "./useTranslations";

const Sponsor = ({ logo, txt, href }) => (
  <div className="column is-narrow">
    <div className="has-text-centered">
      <a href={href}>{logo}</a>

      <a
        className="is-block has-text-grey-dark is-italic is-size-7"
        href={href}
      >
        {txt}
      </a>
    </div>
  </div>
);

const logoProps = {
  width: 105,
};

const Sponsors = ({ ...props }) => {
  // Take all translations in since we create the key dynamically below
  const t = useTranslations();
  const logos = {
    Marmot: (
      <StaticImage
        src="../images/sponsors/marmot.png"
        alt="Marmot logo"
        {...logoProps}
      />
    ),
    Harrikone: (
      <StaticImage
        src="../images/sponsors/harrikone.png"
        alt="Harrikone logo"
        {...logoProps}
      />
    ),
    Greenautomation: (
      <StaticImage
        src="../images/sponsors/green-automation.png"
        alt="Green automation logo"
        {...logoProps}
      />
    ),
    Bridgedale: (
      <StaticImage
        src="../images/sponsors/bridgedale.jpeg"
        alt="Bridgedale logo"
        {...logoProps}
      />
    ),
    Sasta: (
      <StaticImage
        src="../images/sponsors/sasta-black.jpg"
        alt="Sasta logo"
        {...logoProps}
      />
    ),
    Kcm: (
      <StaticImage
        src="../images/sponsors/kcm-jarvenpaa.jpg"
        alt="K-Citymarket Järvenpää logo"
        {...logoProps}
      />
    ),
    Pihla: (
      <StaticImage
        src="../images/sponsors/pihla-logo-ikkunat-ovet.jpg"
        alt="Pihla logo"
        {...logoProps}
      />
    ),
  };

  // Use logos to create list of sponsors, assume we have translations in place
  const sponsorList = Object.keys(logos).map(s => s);

  return (
    <div {...props}>
      <h2 className="is-hidden-desktop has-text-centered mt-6">
        {t["sponsors"]}
      </h2>
      <div className="columns is-desktop is-centered is-vcentered is-variable is-6">
        {sponsorList.map(s => (
          <Sponsor
            key={s}
            logo={logos[s]}
            href={t[`sponsor${s}Link`]}
            txt={t[`sponsor${s}Slogan`]}
          />
        ))}
      </div>
    </div>
  );
};

export default Sponsors;
